import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.splice.js";
import Sortable from 'sortablejs';
import { updateSortedFactoriesApi } from '@/api';

import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'SortSetting',
  data: function data() {
    return {
      clientTop: true,
      initialData: [],
      sortingData: []
    };
  },
  computed: _objectSpread({}, mapState(['sortedFactoryNameList'])),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations(['CHANGE_REALTIME_RELOAD'])), mapActions(['asyncSortedFactories', 'asyncInfo'])), {}, {
    scrollScreen: function scrollScreen(e) {
      this.clientTop = e.target.scrollTop === 0;
    },
    backTop: function backTop() {
      var element = document.getElementById('sortableListId0');
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start'
      });
    },
    resetSortedData: function resetSortedData() {
      this.sortingData = this.initialData;
    },
    checkUpdateSortedData: function checkUpdateSortedData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$swal.fire({
                  icon: 'warning',
                  title: "\u78BA\u5B9A\u66F4\u65B0\u6848\u5834\u6392\u5E8F?",
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: "\u78BA\u5B9A",
                  denyButtonText: "\u53D6\u6D88",
                  reverseButtons: true
                }).then(function (result) {
                  if (result.isConfirmed) {
                    _this.updateSortedFactories(_this.sortingData);
                  }
                });
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    updateSortedFactories: function updateSortedFactories(updateArray) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _result$data, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return updateSortedFactoriesApi(updateArray);
              case 3:
                result = _context2.sent;
                if (!(result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.success)) {
                  _context2.next = 11;
                  break;
                }
                _this2.$swal('更新成功');
                _context2.next = 8;
                return _this2.asyncSortedFactories();
              case 8:
                _context2.next = 10;
                return _this2.asyncInfo();
              case 10:
                _this2.CHANGE_REALTIME_RELOAD(true);
              case 11:
                _context2.next = 17;
                break;
              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                _this2.$swal('更新發生問題，請重試或洽管理員');
                console.log('updateSortedFactoriesApi', _context2.t0);
              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 13]]);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _this3$sortedFactoryN;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if ((_this3$sortedFactoryN = _this3.sortedFactoryNameList) !== null && _this3$sortedFactoryN !== void 0 && _this3$sortedFactoryN.length) {
                _context3.next = 3;
                break;
              }
              _context3.next = 3;
              return _this3.asyncSortedFactories();
            case 3:
              // factoryName list
              _this3.initialData = _this3.sortedFactoryNameList;
              _this3.sortingData = _this3.sortedFactoryNameList;

              // Sortablejs
              _this3.$nextTick(function () {
                Sortable.create(_this3.$refs.sortableList, {
                  sort: true,
                  animation: 500,
                  // 此寫法 fix 資料更新但畫面沒更新
                  onEnd: function onEnd(e) {
                    var clonedItems = _this3.sortingData.filter(function (item) {
                      return item;
                    });
                    clonedItems.splice(e.newIndex, 0, clonedItems.splice(e.oldIndex, 1)[0]);
                    _this3.sortingData = [];
                    _this3.$nextTick(function () {
                      _this3.sortingData = clonedItems;
                    });
                  }
                });
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};